import React, { useEffect, useMemo, useState, useContext } from "react"
import { CloseButton, LocalShadow, PopupButton, PopupWrapper } from "../../../../components/styled/BasicBlocks"
//import { foldersRoot } from "../../../../mocks/dashboard";
import { FullAnalysisFolderList } from "../../../dashboardPage/components/fullAnalysis/FullAnalysisFolderList";
import { IAnalysisFolder } from "../../../dashboardPage/components/fullAnalysis/IAnalysisFolder";
import { FullAnalysisCrumbs } from "../../../dashboardPage/components/fullAnalysis/FullAnalysisCrumbs";
import { IClientData, ISession } from "../../../../types/dashboard";
import { ISubtitles, IVideoResponse } from "../../../../types/videoResponse";
import { ISelectedRange } from "../../../../components/subtitles/SubtitlesTypes";
import { formatDate2 } from "../../../../utils/dateFormats";
import "./SendFolderPopup.css";
import { FullAnalysisFile } from "../../../dashboardPage/components/fullAnalysis/FullAnalysisFile";
import { IFullAnalysisFileRecord } from "../../../dashboardPage/components/fullAnalysis/FullAnalysisTypes";
import { GoodScroll } from "../../../desktopPage/GoodScroll";
import { ServerFileProvider } from "../../../../api/fileProvider/serverProvider";
import { IFileProvider } from "../../../../api/fileProvider/IFileProvider";
import { AnalysisProvider } from "../../../../api/fileProvider/analysisProvider";
import { FileProviderViewer } from "../../../desktopPage/FileProviderViewer";
import { createModalSystem } from "../../../../utils/createModalSystem";
import { FullAnalysisAddFolderPanelNew } from "../../../dashboardPage/components/fullAnalysis/FullAnalysisAddFolderPanel";
import { AppContext } from "../../../../appContext";

interface ISendFolderPopupProps {
    sessionData: IVideoResponse;
    client: IClientData;
    commonSession: ISession,
    selection: any;
    onClose: ()=>void;
    onSubmit: (folderName: string)=>void;
}

function selectedSubtitles(subtitles: ISubtitles, selection: ISelectedRange){
    let wordCount = 0;
    const resultWords: string[] = [];
    subtitles.segments.forEach((segment, segmentIndex)=>{
        segment.words.forEach((word, wordIndex)=>{
            wordCount++;
            if (wordCount >=selection.startId && wordCount<=selection.endId){
                resultWords.push(word.word);
            }
        });
    });
    return resultWords.join(' ');
}

export const SendFolderPopup = ({client, commonSession, sessionData, selection, onClose, onSubmit}: ISendFolderPopupProps)=>{
    const { translate } = useContext(AppContext);
    const [provider, setProvider] = useState<IFileProvider>(null);
    const [selectedItem, setSelectedItem] = useState<IAnalysisFolder>(null);
    const [fix, setFix] = useState(0);
    const popupSystem = createModalSystem();

    const crumbs = provider?.crumbs;
    const currentFolder = provider?.crumbs[provider?.crumbs.length-1];

    useEffect(()=>{
        const _provider = new AnalysisProvider();
        _provider.onChange = ()=>{
            setFix(last=>last+1);
        }
        _provider.getFiles();
        setProvider(_provider);
    }, []);

    const handleCrumb = (folder: IAnalysisFolder)=>{
        /*Crumbs(last=>{
            const crumbIndex = last.indexOf(folder);
            return last.slice(0, crumbIndex+1);
        });*/
        provider.getFiles(folder.id, folder.name);
        setSelectedItem(null);
    }

    const handleSelect = (folder: IAnalysisFolder)=>{
        if (selectedItem == folder){
            if (selectedItem?.type == 'folder'){
                //setCrumbs(last=>[...last, folder]);
                provider.getFiles(folder.id, folder.name);
                setSelectedItem(null);
            }
        } else {
            setSelectedItem(folder);    
        }
    }

    const selectedText = selectedSubtitles(sessionData.output, selection);
    const newRecord: IFullAnalysisFileRecord = {
        name: client.name,
        relatedClientId: client.id,
        tags: [translate('send_folder_client_tag')],
        iconIndex: 0,
        date: formatDate2(new Date()),
        link: `/meeting/${commonSession.client || client.id}/${commonSession.id}`,
        action: translate('send_folder_action_text'),
        linkText: `${formatDate2(new Date(commonSession.date))} ${translate('send_folder_session_suffix')}`,
        chunks: [{
            type: 'quote',
            data: {
                title: translate('send_folder_quote_title'),
                text: selectedText
            }
        }]
    };

    return <LocalShadow className="SendFolderPopup SendFolderPopup_shadow">
        <PopupWrapper>
            <div className="SendFolderPopup_head">
                <div></div>
                <CloseButton onClick={onClose}></CloseButton>
            </div>
            <div className="SendFolderPopup_scroll">
            <GoodScroll>
            <div className="SendFolderPopup_scroll_content">

            {/*crumbs && <FullAnalysisCrumbs
                crumbs={crumbs}
                onCrumb={handleCrumb}
            ></FullAnalysisCrumbs>*/}

            {/*currentFolder && <FullAnalysisFolderList
                folder={currentFolder}
                selectedItem={selectedItem}
                onSelect={handleSelect}
                onAdd={()=>{}}
                onDelete={()=>{}}
                onRename={()=>{}}
            ></FullAnalysisFolderList>*/}
            {<FileProviderViewer
                callModal={popupSystem.callModal}
                FileProvider={AnalysisProvider}
                onSelect={handleSelect}
                AddPanel={FullAnalysisAddFolderPanelNew}
            ></FileProviderViewer>}

            <div className="SendFolderPopup_preview">
                <div className="SendFolderPopup_preview_head">
                    {translate('send_folder_preview')}:
                </div>
                <div className="SendFolderPopup_preview_content">
                    <FullAnalysisFile file={{
                        fileData: [
                            newRecord
                        ],
                        name: '',
                        iconIndex: 0,
                        date: new Date(),
                        type: 'file'
                    }}></FullAnalysisFile>
                    {/*selectedText*/}
                </div>
            </div>
            </div>
            </GoodScroll>
            </div>
            <div className="SendFolderPopup_buttons">
                <PopupButton onClick={()=>{
                    const target = selectedItem || currentFolder;
                    if (!target) return;
                    const updatedFileData = [...(target.fileData || []), newRecord];
                    provider.updateFile({...target, fileData: updatedFileData});
                    onSubmit(target.name || '');
                }}>{translate('send_folder_send_to_selected')}</PopupButton>
            </div>
        </PopupWrapper>
        {popupSystem.modals}
    </LocalShadow>
}